import { Breadcrumb } from 'antd';
import React from "react";

export default (() => {
  return (
    <Breadcrumb style={{textAlign: 'left'}}>
      <Breadcrumb.Item>客户列表</Breadcrumb.Item>
    </Breadcrumb>
  )
})